import { render } from 'preact';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-700.css';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import './ui/styles.css';
import { App } from './ui/app';
import { watchRoute } from './ui/state/screen';
import { watchSystemTheme } from './ui/theme';

watchSystemTheme();
watchRoute();
const root = document.getElementById('app');
if (root) render(<App />, root);
